<template>
	<div class="phcompany">
		<hpheader></hpheader>
		<div class="phcomp-cont">
			<div class="phcompcont-item" v-for="(item,index) in channel_list"  @click="navtomore(item.id)">
				{{item.name}}
			</div>
		</div>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
  import {session} from "../../storage/storage";
	export default{
		data(){
			return{
        channel_list:[],
			}
		},
		created() {
			window.scrollTo(0,0);
			this.ress()
			this.getIndexData();
			if (!(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
			
				this.$router.push({path:'./'})
			}
		},
		components:{
			hpheader
		},
		methods:{
			navtomore(id){
        		session.set("channel_id",id);
				this.$router.push({path: '/phmore'})
				var link = document.querySelector("link[rel*='icon']")
				if(id==1){
					this.backColor="redbacll"
					link.href = 'woodpecker.ico'
				}else if(id==2){
					this.backColor="bluebacll"
					link.href = 'DTE.png'
				}else if(id==3){
					this.backColor="blackBack"
					link.href = 'DBA.png'
					session.set("lang", 'en');
				}else if(id==4){
					this.backColor="blackBack"
					link.href = 'RTA.png'
					session.set("lang", 'en');
				}
			},
			getIndexData() {
				this.$api.pcindex({ mold: "h5",lang:session.get("lang") == null ? 'cn' : session.get("lang") }).then((res) => {
					this.channel_list = res.data;
					console.log('channel_listchannel_listchannel_list',this.channel_list)
					//this.checkChannel();
				});
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phcompany{
		min-height: 100vh;
		background: #F0F2F5;
	}
	.phcomp-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phcomphea-left{
		margin-left: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phcomphea-left img{
		width: 100%;
		height: 100%;
	}
	.phcomphea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phcomphea-right img{
		width: 100%;
		height: 100%;
	}
	.phcomp-cont{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100vh;
		
	}
		
	.phcompcont-item{
		width: 6.9rem;
		height: 1.2rem;
		box-shadow: 0rem 0.01rem 0rem 0rem #CCCCCC;
		display: flex;
		justify-content: center;
		align-items: center;;
		font-size: 0.28rem;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
	}
</style>
